"use client";

import LegalPage from "@/components/legal/LegalPage";

export default function CookiePolicy() {
  return (
    <LegalPage
      pageTitle="Cookie Policy"
      subtitle="How we use cookies to enhance your experience"
      legalKey="cookie_policy"
    />
  );
}
